import ToastStore from '@store/toast/ToastStore';

export function toast(message: string) {
  return ToastStore.addToast({
    type: 'success',
    message,
  });
}

export function errorToast(message = 'There was a problem communicating with the server.') {
  return ToastStore.addToast({
    type: 'error',
    message,
  });
}
